import * as Actions from '../actions';
import RichTextEditor from 'react-rte';

const initialState = {
    userNoteList:                [],
    new_note_count:              0,
    current_user_note_id:        0,
    current_user_note_detail_id: 0,
    current_note_text:           RichTextEditor.createEmptyValue(),
    current_tab:                 0,
    edit_tab_name:               '',
}

function calcNewCurrentID(userNoteList, current_user_note_detail_id) {
    let new_detail_id        = 0;
    let new_note_text        = '';
    let found_current        = false;
    let active_detail_id     = 0;
    let active_note_text     = '';


    userNoteList.forEach((user_note_detail) => {
        if(user_note_detail.Active) {
            active_detail_id = user_note_detail.user_note_detail_id;
            active_note_text = user_note_detail.NoteText;
        }
        
        if(user_note_detail.user_note_detail_id === current_user_note_detail_id) {
            found_current = true;
        } else {
            if(found_current && new_detail_id === 0 && user_note_detail.Active) {
                new_detail_id   = user_note_detail.user_note_detail_id;
                new_note_text   = user_note_detail.NoteText;
            }
        }
    });

    if(new_detail_id === 0) {
        new_detail_id = active_detail_id;
        new_note_text = active_note_text;
    }

    return { new_detail_id, new_note_text };
}

function findActiveIndex(user_note_detail_id, activeUserNoteList) {
    let active_index = 0;

    activeUserNoteList.forEach((detail, index) => {
        if(detail.user_note_detail_id === user_note_detail_id) {
            active_index = index;
        }
    })

    return active_index;
}

const userNoteReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_USER_NOTE_LIST):
        {
            const { userNoteList, user_note_id } = action.payload;
            const activeUserNoteList = userNoteList.filter((detail) => detail.Active);

            // Get first NoteDetail if available
            let detail_id = 0;
            let note_text = RichTextEditor.createValueFromString('', 'html');
            if (activeUserNoteList.length > 0) {
                detail_id = userNoteList[0].user_note_detail_id;
                note_text = RichTextEditor.createValueFromString(userNoteList[0].NoteText, 'html');
            }
            
            let new_current_tab = findActiveIndex(detail_id, activeUserNoteList);

            return {
                ...state,
                userNoteList:                userNoteList,
                current_user_note_detail_id: state.current_user_note_detail_id === 0 ? detail_id : state.current_user_note_detail_id,
                current_note_text:           note_text,
                current_user_note_id:        user_note_id,
                current_tab:                 new_current_tab,
            }
        }

        case (Actions.UPDATE_USER_NOTE_DETAIL):
        {
            const { user_note_detail_id, note_text } = action.payload;
            
            return {
                ...state,
                userNoteList: state.userNoteList.map((user_note_detail) => {
                    if (user_note_detail.user_note_detail_id === user_note_detail_id) {
                        return {
                            ...user_note_detail,
                            NoteText: note_text,
                        }
                    } else {
                        return user_note_detail;
                    }
                })
            }
        }

        case (Actions.SET_CURRENT_NOTE_TEXT):
        {
            const { note_text, user_note_detail_id } = action.payload;
            
            return {
                ...state,
                current_note_text:           note_text,
                current_user_note_detail_id: user_note_detail_id,
            }
        }

        case (Actions.UPDATE_CURRENT_NOTE_TEXT):
        {
            const rte_value = action.payload;

            return {
                ...state,
                current_note_text: rte_value,
                userNoteList: state.userNoteList.map((user_note_detail) => {
                    if(user_note_detail.user_note_detail_id === state.current_user_note_detail_id) {
                        return {
                            ...user_note_detail,
                            NoteText: rte_value.toString('html'),
                        }
                    } else {
                        return user_note_detail;
                    }
                })
            }
        }

        case (Actions.UPDATE_TAB_NAME):
        {
            const { tab_name, user_note_detail_id } = action.payload;

            return {
                ...state,
                userNoteList: state.userNoteList.map((user_note_detail) => {
                    if(user_note_detail.user_note_detail_id === user_note_detail_id) {
                        return {
                            ...user_note_detail,
                            ChapterName: tab_name
                        };
                    } else {
                        return user_note_detail;
                    }
                })
            }
        }

        case (Actions.SET_ACTIVE_TAB):
        {
            const { user_note_detail_id, active_value } = action.payload;   
            let new_detail_id   = state.current_user_note_detail_id;
            let new_note_text   = state.current_note_text;

            // Set Active flag for new list
            const new_user_note_list = state.userNoteList.map((user_note_detail) => {
                if(user_note_detail.user_note_detail_id === user_note_detail_id) {
                    return {
                        ...user_note_detail,
                        Active: active_value,
                    };
                } else {
                    return user_note_detail;
                }
            });

            // Get list of only Active notes
            const activeUserNoteList = new_user_note_list.filter((detail) => detail.Active);

            // If moving from no active tabs to one active tab
            if(activeUserNoteList.length > 0 && (state.userNoteList.filter((detail) => detail.Active)).length === 0) {
                new_detail_id   = activeUserNoteList[0].user_note_detail_id;
                new_note_text   = RichTextEditor.createValueFromString(activeUserNoteList[0].NoteText, 'html');
            } else {
                // If deactivating currently selected tab, need to figure out what the new active tab will be
                if(user_note_detail_id === new_detail_id) {
                    const result    = calcNewCurrentID(new_user_note_list, state.current_user_note_detail_id);
                    new_detail_id   = result.new_detail_id;
                    new_note_text   = RichTextEditor.createValueFromString(result.new_note_text, 'html');
                }
            }

            let new_current_tab = findActiveIndex(new_detail_id, activeUserNoteList);
            return {
                ...state,
                current_note_text:           new_note_text,
                current_user_note_detail_id: new_detail_id,
                current_tab:                 new_current_tab,
                userNoteList:                new_user_note_list,
            }
        }

        case (Actions.ADD_NEW_TAB):
        {
            const chapter_name        = action.payload;
            const user_note_detail_id = 'new_' + state.new_note_count;

            return {
                ...state,
                userNoteList: state.userNoteList.push({
                    user_note_detail_id: user_note_detail_id,
                    NoteText: '',
                    ChapterName: chapter_name,
                    Active: 1,
                    is_new: true,
                }),
                new_note_count: (state.new_note_count + 1),
                current_user_note_detail_id: user_note_detail_id,
            }
        }

        case (Actions.SET_CURRENT_TAB):
        {
            const new_current_tab = action.payload;
            const activeUserNoteList = state.userNoteList.filter((detail) => detail.Active);

            return {
                ...state,
                current_tab:                 new_current_tab,
                current_note_text:           RichTextEditor.createValueFromString(activeUserNoteList[new_current_tab].NoteText, 'html'),
                current_user_note_detail_id: activeUserNoteList[new_current_tab].user_note_detail_id,
            }
        }

        case (Actions.EDIT_TAB_NAME):
        {
            const tab_name = action.payload;

            return {
                ...state,
                edit_tab_name: tab_name
            }
        }

        case (Actions.RE_PULL_USER_NOTE_DETAIL_ASSETS):
        {
            return {
                ...state,
                userNoteList: state.userNoteList.map(note => {
                    if (note.user_note_detail_id === action.payload.user_note_detail_id) {
                        return {
                            ...note,
                            AssetList: action.payload.data
                        }
                    }
                    return note
                })
            }
        }

        default:
        {
            return state;
        }

    }
}

export default userNoteReducer;


// WEBPACK FOOTER //
// src/main/components/note/store/reducers/user_note.reducer.js